
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import PaginaInformativa, { Sezione } from '../components/PaginaInformativa';
Privacy.paginaPubblica = true;
export default function Privacy() {
    return (<PaginaInformativa titolo="Informativa sulla privacy" sottotitolo="Come vengono trattati i dati in questo ambiente dimostrativo." aggiornamento="6 agosto 2026">
      <p>
        Dimora è un ambiente dimostrativo pubblicato da Giuseppe Delli Paoli a
        scopo di presentazione del prodotto. Non è un servizio commerciale e
        non raccoglie dati personali a fini di marketing o profilazione.
      </p>

      <Sezione titolo="Dati presenti nella demo">
        <p>
          Immobili, inquilini, contratti e pagamenti che vedi nella demo sono
          dati di fantasia. Ogni somiglianza con persone o società reali è
          casuale. I dati di esempio possono essere modificati liberamente dai
          visitatori e vengono ripristinati periodicamente.
        </p>
      </Sezione>

      <Sezione titolo="Dati raccolti">
        <p>
          L&apos;accesso alla demo non richiede registrazione: non ti vengono
          chiesti nome, email o altri dati personali. L&apos;applicazione usa
          esclusivamente cookie tecnici di sessione, necessari al
          funzionamento dell&apos;area riservata. Non sono presenti strumenti
          di tracciamento o analisi di terze parti.
        </p>
      </Sezione>

      <Sezione titolo="Una raccomandazione">
        <p>
          Trattandosi di un ambiente condiviso e periodicamente ripristinato,
          non inserire dati personali reali, tuoi o di altre persone.
        </p>
      </Sezione>

      <Sezione titolo="Titolare e contatti">
        <p>
          Per qualsiasi domanda su questa informativa puoi scrivere ai
          recapiti indicati nella pagina dei contatti.
        </p>
      </Sezione>
    </PaginaInformativa>);
}

    async function __Next_Translate__getStaticProps__19fd5e3c69c__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/privacy',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19fd5e3c69c__ as getStaticProps }
  